import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  static targets = ['activationDateInput', 'total', 'totalBox'];
  static values = {
    monthlyPrice: String,
  }

  connect() {
    this._calculate();
    this.activationDateInputTarget.addEventListener('change', () => {
      this._calculate();
    });
  }

  _calculate() {
    if (this.activationDateInputTarget.value === 'null') {
      this.totalBoxTarget.classList.add('d-none');
      return;
    } else {
        this.totalBoxTarget.classList.remove('d-none');
    }

    const activationDate = new Date(this.activationDateInputTarget.value);
    const monthlyPrice = parseFloat(this.monthlyPriceValue);
    
    const currentYear = activationDate.getFullYear();
    const currentMonth = activationDate.getMonth();
    const currentDay = activationDate.getDate();
    const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const remainingDays = daysInMonth - currentDay + 1;

    const dailyRate = monthlyPrice / daysInMonth;
    const currentMonthPrice = +(dailyRate * remainingDays).toFixed(2);
    const nextMonthPrice = +monthlyPrice.toFixed(2);
    const total = +(currentMonthPrice + nextMonthPrice).toFixed(2);

    this.totalTarget.innerHTML =
        `${currentMonthPrice.toFixed(2)} € + ${nextMonthPrice.toFixed(2)} € = ${total.toFixed(2)} €`;
  }
}
